// extracted by mini-css-extract-plugin
export var colorSquare = "_j0-0";
export var danger = "_j0-5";
export var lightPink = "_j0-8";
export var neutralBlue = "_j0-7";
export var neutralYellow = "_j0-6";
export var normal = "_j0-1";
export var primary = "_j0-2";
export var primaryLight = "_j0-3";
export var solidBlack = "_j0-g";
export var solidGreen = "_j0-b";
export var solidLightBlue = "_j0-d";
export var solidNavy = "_j0-c";
export var solidOrange = "_j0-f";
export var solidPink = "_j0-e";
export var solidRed = "_j0-9";
export var solidYellow = "_j0-a";
export var success = "_j0-4";